const features = [
  {
    title: 'Licensed and Insured Professionals',
    description: 'All our technicians are fully licensed, certified, and insured for your peace of mind.'
  },
  {
    title: 'Fast and Reliable Service',
    description: 'We respond quickly to your needs and complete projects on time, every time.'
  },
  {
    title: 'Honest Pricing',
    description: 'Transparent quotes with no hidden fees. You know exactly what you\'re paying for.'
  },
  {
    title: 'Local and Family Owned',
    description: 'We\'re part of your community and treat every home like it\'s our own.'
  },
  {
    title: 'Customer Satisfaction Guaranteed',
    description: 'We stand behind our work with a 100% satisfaction guarantee on all services.'
  }
];

export default function WhyChooseUs() {
  return (
    <section id="why-us" className="py-20 md:py-36 px-4 sm:px-6 bg-[#F8F9FA]">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          {/* Left Column */}
          <div className="lg:w-2/5">
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-[#2C2C2C] leading-tight mb-5">
              Why Homeowners Choose Us
            </h2>
            <p className="text-base sm:text-lg text-[#6B6B6B] leading-relaxed">
              We combine years of experience with a commitment to excellence, ensuring every project is completed to the highest standards.
            </p>
          </div>

          {/* Right Column */}
          <div className="lg:w-3/5 space-y-7">
            {features.map((feature, index) => (
              <div key={index} className="flex items-start">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#1e40af] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-xl sm:text-2xl text-white"></i>
                </div>
                <div className="ml-4 sm:ml-5">
                  <h3 className="text-base sm:text-xl font-bold text-[#2C2C2C] mb-1.5">{feature.title}</h3>
                  <p className="text-sm sm:text-base text-[#6B6B6B] leading-relaxed">{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
